import { useI18n } from "@/i18n/I18nProvider";
import ex01Before from "@/assets/ex-01-before.jpg";
import ex01After from "@/assets/ex-01-after.jpg";
import ex02Before from "@/assets/ex-02-before.jpg";
import ex02After from "@/assets/ex-02-after.jpg";
import ex03Before from "@/assets/ex-03-before.jpg";
import ex03After from "@/assets/ex-03-after.jpg";
import ex04Before from "@/assets/ex-04-before.jpg";
import ex04After from "@/assets/ex-04-after.jpg";
import ex05Before from "@/assets/ex-05-before.jpg";
import ex05After from "@/assets/ex-05-after.jpg";
import ex06Before from "@/assets/ex-06-before.jpg";
import ex06After from "@/assets/ex-06-after.jpg";
import ex07Before from "@/assets/ex-07-before.jpg";
import ex07After from "@/assets/ex-07-after.jpg";
import ex08Before from "@/assets/ex-08-before.jpg";
import ex08After from "@/assets/ex-08-after.jpg";
import ex09Before from "@/assets/ex-09-before.png";
import ex09After from "@/assets/ex-09-after.jpg";
import ex10Before from "@/assets/ex-10-before.png";
import ex10After from "@/assets/ex-10-after.jpg";
import ex11Before from "@/assets/ex-11-before.png";
import ex11After from "@/assets/ex-11-after.jpg";
import ex12Before from "@/assets/ex-12-before.png";
import ex12After from "@/assets/ex-12-after.jpg";
import ex13Before from "@/assets/ex-13-before.jpg";
import ex13After from "@/assets/ex-13-after.jpg";
import ex14Before from "@/assets/ex-14-before.png";
import ex14After from "@/assets/ex-14-after.jpg";
import ex15Before from "@/assets/ex-15-before.png";
import ex15After from "@/assets/ex-15-after.jpg";
import ex16Before from "@/assets/ex-16-before.png";
import ex16After from "@/assets/ex-16-after.jpg";

type Example = {
  before: string;
  after: string;
  styleKey: string;
  alt: string;
};

const EXAMPLES: Example[] = [
  { before: ex01Before, after: ex01After, styleKey: "style.neon", alt: "Woman portrait" },
  { before: ex02Before, after: ex02After, styleKey: "style.anime", alt: "Boy portrait" },
  { before: ex03Before, after: ex03After, styleKey: "style.comic", alt: "Young man portrait" },
  { before: ex04Before, after: ex04After, styleKey: "style.cartoon", alt: "Man portrait" },
  { before: ex05Before, after: ex05After, styleKey: "style.ghibli", alt: "Asian girl portrait" },
  { before: ex06Before, after: ex06After, styleKey: "style.oil", alt: "Man portrait" },
  { before: ex07Before, after: ex07After, styleKey: "style.disney", alt: "Boy portrait" },
  { before: ex08Before, after: ex08After, styleKey: "style.headshot", alt: "Business woman" },
  { before: ex09Before, after: ex09After, styleKey: "style.caricature", alt: "Family portrait" },
  { before: ex10Before, after: ex10After, styleKey: "style.pencil", alt: "Man portrait" },
  { before: ex11Before, after: ex11After, styleKey: "style.popart", alt: "Woman portrait" },
  { before: ex12Before, after: ex12After, styleKey: "style.vintage", alt: "Man portrait" },
  { before: ex13Before, after: ex13After, styleKey: "style.watercolor", alt: "Woman portrait" },
  { before: ex14Before, after: ex14After, styleKey: "style.art_nouveau", alt: "Woman portrait" },
  { before: ex15Before, after: ex15After, styleKey: "style.low_poly", alt: "Boy portrait" },
  { before: ex16Before, after: ex16After, styleKey: "style.stained_glass", alt: "Dog portrait" },
];

export const Examples = () => {
  const { t } = useI18n();
  return (
    <section className="py-16 px-4 bg-muted/30">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold mb-3 text-gradient">{t("examples.title")}</h2>
          <p className="text-gradient">{t("examples.subtitle")}</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {EXAMPLES.map((ex, i) => (
            <div key={i} className="rounded-2xl border border-border bg-card overflow-hidden shadow-sm">
              <div className="grid grid-cols-2">
                <div className="relative">
                  <img src={ex.before} alt={`${ex.alt} before`} loading="lazy" width={768} height={768} className="w-full h-full object-cover aspect-square" />
                  <span className="absolute top-1.5 left-1.5 text-[9px] font-semibold uppercase tracking-wider bg-background/80 backdrop-blur-sm px-1.5 py-0.5 rounded">
                    {t("examples.before")}
                  </span>
                </div>
                <div className="relative">
                  <img src={ex.after} alt={`${ex.alt} after, ${t(ex.styleKey)} style`} loading="lazy" width={768} height={768} className="w-full h-full object-cover aspect-square" />
                  <span className="absolute top-1.5 right-1.5 text-[9px] font-semibold uppercase tracking-wider bg-primary text-primary-foreground px-1.5 py-0.5 rounded">
                    {t("examples.after")}
                  </span>
                </div>
              </div>
              <div className="p-2 text-center">
                <p className="text-xs font-semibold">{t(ex.styleKey)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
